<template>
  <div
    class="tooltip-container"
    @mouseover="onMouseOver"
    @mouseout="onMouseOut"
    @mousemove="onMouseMove"
  >
    <slot></slot>
    <div
      ref="tooltip"
      v-show="isShow"
      class="tooltipex"
      :class="
        'tooltipex-' +
        placement +
        (isAdjust ? ' adjust' : '') +
        ' ' +
        contentClass
      "
      @mouseover="onContentOver"
      @mouseout="onContentOut"
      :style="{ left: left + 'px', top: top + 'px', maxWidth: maxWidth + 'px' }"
    >
      <div class="tooltipex-arrow" ref="arrow"></div>
      <div class="tooltipex-content">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TooltipEx",
  props: {
    placement: {
      type: String,
      default: "right",
    },
    maxWidth: {
      type: Number,
      default: 500,
    },
    delay: {
      type: Number,
      default: 500,
    },
    openMode: {
      type: String,
      default: "1",
    },
    contentClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isShow: false,
      timer: 0,
      left: 0,
      top: 0,
      popperTimer: 0,
      isAdjust: false,
    };
  },
  methods: {
    showContent() {
      if (!this.$refs.tooltip) {
        return;
      }
      let el = this.$slots.default[0].elm;
      let rect = el.getBoundingClientRect();
      let contentRect = this.$refs.tooltip.getBoundingClientRect();
      let height = document.documentElement.clientHeight;
      if (this.placement == "right" || this.placement == "left") {
        if (!this.isAdjust) {
          if (this.placement == "right") {
            this.left = rect.left + rect.width + 8;
          } else {
            this.left = rect.left - 32;
          }
          this.top = rect.top - (contentRect.height - rect.height) / 2;
        }
        if (this.top < 0) {
          this.isAdjust = true;
          this.top = 0;
        } else if (height < this.top + contentRect.height) {
          this.isAdjust = true;
          this.top = height - contentRect.height;
        }
        this.$refs.arrow.style.top =
          (rect.top - this.top + rect.height / 2).toString() + "px";
      }
    },
    delayShow() {
      if (this.popperTimer) {
        return;
      }
      this.popperTimer = setTimeout(() => {
        if (this.isShow) {
          return;
        }
        this.isShow = true;
        this.$emit("on-popper-show");
        this.$nextTick(() => {
          document.body.appendChild(this.$refs.tooltip);
          this.isAdjust = false;
          this.showContent();
        });
      }, this.delay);
    },
    onMouseOver() {
      if (this.openMode == 1) {
        this.delayShow();
      }
    },
    close() {
      clearTimeout(this.popperTimer);
      this.popperTimer = 0;

      this.timer = setTimeout(() => {
        this.isShow = false;
      }, 100);
    },
    onMouseOut() {
      this.close();
    },
    onMouseMove() {
      clearTimeout(this.timer);
    },
    onContentOver() {
      clearTimeout(this.timer);
    },
    onContentOut() {
      this.close();
    },
  },
  updated() {
    this.$nextTick(() => {
      this.showContent();
    });
  },
};
</script>
<style lang="scss" scoped>
.tooltipex {
  position: fixed;
  z-index: 9999;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
  padding: 8px 12px;
  box-sizing: border-box;
}
.tooltipex-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border: 8px solid transparent;
  transform: translateY(-50%);
}
.tooltipex-right {
  .tooltipex-arrow {
    border-right-color: white;
    left: -16px;
  }
}
.tooltipex-left {
  transform: translateX(-100%);
  .tooltipex-arrow {
    border-left-color: white;
    right: -16px;
  }
}
.tooltipex-content {
  max-height: calc(100vh - 50px);
  overflow-y: auto;
  @include thinScrollbar();
}
</style>
